<template>
  <v-timeline-item
    color="accent"
    large
    icon="far fa-door-open">
    <v-card @click="$emit('clickItem')">
      <v-card-title class="body-2">{{item.start_time}}</v-card-title>
      <v-card-text>
        {{item.employee.phone}} visited <span class="font-weight-black">{{item.room.name}}</span>
        ({{item.average_rssi}}/{{item.minimal_rssi || 'no minimal'}}) <br>
        <span class="font-weight-black">Profile:</span> {{ item.profile || 'undefined' }}<br>
        <span class="font-weight-black">Mode:</span> {{ item.mode || 'undefined' }}
      </v-card-text>
    </v-card>
  </v-timeline-item>
</template>

<script>
export default {
  name: 'Room',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
